import BurgerMenu from './BurgerMenu/BurgerMenu';
import DesktopMenu from './DesktopMenu/DesktopMenu';
import useMediaQuery from '@/v2/hooks/mediaQueries/useMediaQuery';
import MediaQueryBreakpoints from '@/v2/constants/MediaQueryBreakpoints';

export default function Menu() {
  const showBurguerMenu = useMediaQuery({
    query: `(max-width: ${MediaQueryBreakpoints.mobileMenuBreakpoint}px)`,
  });

  if (showBurguerMenu) {
    return <BurgerMenu />;
  }

  return <DesktopMenu />;
}
